import Alpine from 'alpinejs';

globalThis.alpine = Alpine;

Alpine.start();
